import { Component, viewChild } from '@angular/core';
import {
  Button,
  PopoverComponent,
  SimpleDialog,
  SimpleDialogLayout,
  SimplePopoverLayout,
} from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';

import { environment } from '../../../../../environments/environment';
import { FeatureEnabledDirective } from '../../../../shared/directives/feature-enabled';
import { YoutubeEmbed } from '../../../../shared/components/youtube-embed/youtube-embed';

@Component({
  selector: 'app-tutorial-analysis-popover',
  imports: [
    PopoverComponent,
    NgIcon,
    Button,
    SimplePopoverLayout,
    SimpleDialog,
    SimpleDialogLayout,
    FeatureEnabledDirective,
    YoutubeEmbed,
    TranslocoPipe,
  ],
  templateUrl: './tutorial-analysis-popover.html',
})
export class TutorialAnalysisPopover {
  private tutorialPopover = viewChild<PopoverComponent>('tutorialPopover');

  protected embedVideoUrl = environment.tutorialVideoEmbedLinks.analysis;

  showPopover() {
    this.tutorialPopover()?.show();
  }
}
